<template>
  <div class="sip_ui_border">
    <div class="sip_status sip_ui_body" :data-score="score">
      <div class="sip_status_title">
        <img :srcset="`${$server}logo.png 1x, ${$server}logo_2x.png 2x`" :src="`${$server}logo.png`" />
      </div>
      <div @click="onModal" class="sip_status_help">
        Правила
        <div class="sip_status_help_icon">i</div>
      </div>
      <div class="sip_divide" />
      <div class="sip_status_body">
        <!-- <Timer :timer="timer" /> -->
        <!-- <div class="sip_status_scale" >
          <div class="sip_status_scale_line" ref="line" />
          <div v-html="scale" />
        </div>
        <div class="sip_status_scale_note">прогресс заправки</div>

      <div class="sip_divide" /> -->

      <div class="sip_status_btn" @click="$emit('clickAbout')">
        <span>Справка</span>
      </div>

      </div>

    </div>
  </div>
</template>
<script>
import StatusScale from './StatusScale.vue'
import Timer from './Timer.vue'

const scale = `<svg width="168" height="14" viewBox="0 0 168 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="sip_green" d="M19.3493 1C15.7802 4.18367 24.4456 8.71429 19.3493 13L5.99999 13C3.23857 13 1 10.7614 1 8L1 6C1 3.23858 3.23858 0.999999 6 0.999999L19.3493 1Z" fill="#5BAF09"/>
  <rect x="148" y="3" width="3" height="144" rx="1.5" transform="rotate(90 148 3)" fill="white" fill-opacity="0.46"/>
  <rect x="164" y="3" width="3" height="13" rx="1.5" transform="rotate(90 164 3)" fill="white" fill-opacity="0.46"/>
  <defs>
    <filter id="filter0_i" x="0" y="0" width="168" height="14" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="4"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
    </filter>
    <linearGradient id="paint0_linear" x1="168" y1="7" x2="-3.0598e-07" y2="7" gradientUnits="userSpaceOnUse">
      <stop stop-color="#4E737E"/>
      <stop offset="1" stop-color="#435C64"/>
    </linearGradient>
  </defs>
</svg>`

export default {
  name: 'Status',
  data() {
    return {
      scale,
      pers: -100,
    }
  },
  props: ['score', 'timer', 'id'],
  components: {
    StatusScale,
    Timer,
  },
  methods: {
    onModal() {
      this.$emit('clicked', 'main-modal-help')
    },
    progress() {
      console.log('Progress');
      if(this.id === 4) {

        setTimeout(() => {
          this.$emit('refill', true)
        }, 1000);

      }else{

        let id = setInterval(()=>{
          if(this.pers < 0) {
            this.pers++
          }else{
            this.$emit('refill', true)
            this.pers = -100
            clearInterval(id)
          }
          // this.$refs.line.style.transform = `translate(${this.pers}%)`
        }, 80)


      }
      
    }
  }
}
</script>

<style lang="stylus">
.sip_status_title
  font-weight bold
  font-size 21px
  line-height 25px
  text-align center
  >img
    margin-bottom -12px
.sip_divide
  width 100%
  height 1px
  margin 10px auto
  border: 1px solid rgba(78, 114, 125, 0.85);
  box-shadow 0px 1px 0px #FFFFFF
.sip_status_help
  font-weight 500
  font-size 11px
  line-height 89.19%
  margin 15px 0 15px 24px
  text-decoration underline
  position relative
  cursor pointer
  .sip_status_help_icon
    position absolute
    top -5px
    left -24px
    width 20px
    height 20px
    background-color #599EC4
    border 1px solid #FFF
    border-radius 50%
    color #FFF
    padding 5px
    text-align center
.sip_status_body
  .sip_status_scale
    margin-top 10px
    width 100%
    height 15px
    background: linear-gradient(180deg, #4E737E 0%, #435C64 100%);
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    box-shadow: inset 0px 4px 0px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    position relative
    overflow hidden
    .sip_status_scale_line
      position absolute
      top 0
      left 0
      width 170px
      height 13px
      background #5BAF09
      z-index 1
      border-top-left-radius 6px
      border-bottom-left-radius 6px
      transform translateX(-100%)
      border-radius 6px
      animation blink .6s infinite;
    svg
      position relative
      z-index 2
    .sip_green
      transform translateX(10px)
  .sip_status_scale_note
    font-size 10px
    line-height 12px
    margin-left 3px
    margin-bottom -3px
  .sip_status_btn
    background #2F7F98
    border 1px solid #FFFFFF
    box-sizing border-box
    box-shadow inset 0px -3px 0px rgba(0, 0, 0, 0.2)
    border-radius 6px
    padding 10px
    text-align center
    cursor pointer
    span
      font-size 14px
      line-height 92%
      text-align center
      color #FFFFFF
      text-shadow 0px 1px 0px rgba(0, 0, 0, 0.25)
  .sip_status_time_w
    background #3E6470
    border 1px solid #FFFFFF
    box-sizing border-box
    box-shadow inset 0px 4px 0px rgba(0, 0, 0, 0.25)
    border-radius 6px
    display flex
    justify-content space-between
    font-family Roboto
    font-size 10px
    line-height 100%
    color #FFF
    padding 0px 7px
    .sip_status_time_label
      margin-top 16px
    .sip_status_time
      font-family 'Cute Font', cursive
      font-size 36px
      line-height 1
      color #A6D47A
  // .sip_status_body_titles
  //   display flex
  //   flex-direction column
  //   justify-content center
  //   // margin-top 8px
  //   .sip_status_body_title
  //     position relative
  //     // border 1px solid #000
  //     width: 100px;
  //     height: 39px;
  //     img
  //       opacity 0
  //       position absolute
  //       top 50%
  //       left 0
  //       transform translateY(-50%)
  //     span
  //       color #000
  //       position absolute
  //       top 50%
  //       left 6px
  //       transform translateY(-57%)

  //     // &:first-child
  //     //   padding-top 10px
  //   .sip_status_body_title__active
  //     img
  //       opacity 1
  //     span
  //       color #FFF

@keyframes blink{
    0%  { background-color: #FF6240; }
    100%{ background-color: #5BAF09; }
}

</style>